var _rect, _circle, _ellipse, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_10662)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 263.454,
    cy: 267.501,
    r: 107.501,
    fill: "#1C1B1F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.453,
    cy: 275.942,
    rx: 52.3429,
    ry: 52.9057,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 234.749,
    cy: 262.434,
    r: 21.3874,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269.635 332.06C381.147 329.864 423.051 388.965 430.064 418.79L100 418.79C128.273 355.115 177.585 332.06 269.635 332.06Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M430.064 418.79C423.051 388.965 381.147 329.864 269.635 332.06C177.585 332.06 128.273 355.115 100 418.79",
    stroke: "#1C1B1F",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.494 198.73C148.982 200.926 107.078 141.825 100.064 112H430.129C401.856 175.675 352.544 198.73 260.494 198.73Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.064 112C107.078 141.825 148.982 200.926 260.494 198.73C352.544 198.73 401.856 175.675 430.129 112",
    stroke: "#1C1B1F",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.784 474.682C-60.5339 363.822 -227.923 426.924 -293.101 474.594C-294.678 475.748 -294.681 478.01 -293.15 479.224C-235.44 524.959 -129.283 600.761 -88.4621 600.761C-37.3182 600.761 67.3376 521.507 116.213 479.444C117.73 478.139 117.478 475.747 115.784 474.682Z",
    fill: "#1C1B1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M311 453.228L572.528 380",
    stroke: "#1C1B1F",
    strokeWidth: 23,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M307.59 511.703L575.938 553.524",
    stroke: "#1C1B1F",
    strokeWidth: 23,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M210.06 438.959C217.117 401.742 246.325 372.701 260.047 362.833C304.741 376.367 315.261 419.223 314.935 438.959C318.855 495.631 278.016 503.455 257.107 500.283C211.628 494.362 206.793 456.934 210.06 438.959Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_226_10662",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 172,
    y: 329,
    width: 183,
    height: 197
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 329,
    width: 182.305,
    height: 196.66,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_226_10662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.153 509.27C245.809 509.27 231.345 502.852 219.761 490.014C208.177 477.177 202.385 461.198 202.385 442.078C202.385 433.611 204.157 425.144 207.702 416.676C211.247 408.209 215.678 400.083 220.995 392.299C226.312 384.514 232.073 377.208 238.276 370.379C244.479 363.551 250.24 357.61 255.557 352.557C256.57 351.465 257.741 350.679 259.07 350.201C260.4 349.723 261.76 349.484 263.153 349.484C264.546 349.484 265.907 349.723 267.236 350.201C268.565 350.679 269.736 351.465 270.749 352.557C276.066 357.61 281.827 363.551 288.03 370.379C294.234 377.208 299.994 384.514 305.311 392.299C310.628 400.083 315.059 408.209 318.604 416.676C322.149 425.144 323.921 433.611 323.921 442.078C323.921 461.198 318.129 477.177 306.545 490.014C294.962 502.852 280.497 509.27 263.153 509.27ZM263.153 492.882C276.32 492.882 287.207 488.068 295.816 478.44C304.425 468.812 308.729 456.691 308.729 442.078C308.729 432.109 304.9 420.842 297.24 408.277C289.581 395.713 278.219 381.988 263.153 367.102C248.088 381.988 236.725 395.713 229.066 408.277C221.407 420.842 217.577 432.109 217.577 442.078C217.577 456.691 221.881 468.812 230.49 478.44C239.099 488.068 249.987 492.882 263.153 492.882ZM265.242 484.688C266.761 484.551 268.059 483.903 269.135 482.742C270.211 481.581 270.749 480.181 270.749 478.542C270.749 476.63 270.179 475.094 269.04 473.933C267.901 472.772 266.445 472.26 264.672 472.397C259.482 472.806 253.975 471.27 248.151 467.787C242.327 464.305 238.656 457.989 237.137 448.838C236.883 447.336 236.219 446.107 235.143 445.151C234.067 444.195 232.832 443.717 231.44 443.717C229.667 443.717 228.211 444.434 227.072 445.868C225.932 447.302 225.553 448.975 225.932 450.887C228.085 463.315 233.149 472.192 241.125 477.518C249.1 482.844 257.14 485.234 265.242 484.688Z",
    fill: "#1C1B1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_10662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/안과_안와염증.36a504795f0cab0db44ed4edcf70085d.svg";
export { ForwardRef as ReactComponent };